// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
  width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.login-card .ant-card-head-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}

.admin-layout {
  min-height: 100vh;
}

.admin-header {
  background: #001529;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  color: white;
}

.admin-header h1 {
  color: white;
  margin: 0;
  font-size: 20px;
}

.admin-sider {
  background: #001529;
}

.admin-content {
  margin: 24px;
  padding: 24px;
  background: white;
  min-height: 280px;
}

.page-header {
  margin-bottom: 24px;
}

.action-buttons {
  margin-bottom: 16px;
  display: flex;
  gap: 8px;
}

.image-preview {
  max-width: 100px;
  max-height: 100px;
  object-fit: cover;
  cursor: pointer;
}

.modal-image-preview {
  max-width: 100%;
  height: auto;
}

.upload-section {
  margin-top: 16px;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 4px;
}

.file-list {
  margin-top: 16px;
  max-height: 300px;
  overflow-y: auto;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.file-item:hover {
  background: #fafafa;
}

.stats-card {
  text-align: center;
}

.stats-card .ant-statistic-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.stats-card .ant-statistic-content {
  font-size: 24px;
  color: #1890ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminStyles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".login-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n}\r\n\r\n.login-card {\r\n  width: 400px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.login-card .ant-card-head-title {\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.admin-layout {\r\n  min-height: 100vh;\r\n}\r\n\r\n.admin-header {\r\n  background: #001529;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 24px;\r\n  color: white;\r\n}\r\n\r\n.admin-header h1 {\r\n  color: white;\r\n  margin: 0;\r\n  font-size: 20px;\r\n}\r\n\r\n.admin-sider {\r\n  background: #001529;\r\n}\r\n\r\n.admin-content {\r\n  margin: 24px;\r\n  padding: 24px;\r\n  background: white;\r\n  min-height: 280px;\r\n}\r\n\r\n.page-header {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.action-buttons {\r\n  margin-bottom: 16px;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.image-preview {\r\n  max-width: 100px;\r\n  max-height: 100px;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n}\r\n\r\n.modal-image-preview {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.upload-section {\r\n  margin-top: 16px;\r\n  padding: 16px;\r\n  background: #f5f5f5;\r\n  border-radius: 4px;\r\n}\r\n\r\n.file-list {\r\n  margin-top: 16px;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.file-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.file-item:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n.stats-card {\r\n  text-align: center;\r\n}\r\n\r\n.stats-card .ant-statistic-title {\r\n  font-size: 14px;\r\n  color: rgba(0, 0, 0, 0.65);\r\n}\r\n\r\n.stats-card .ant-statistic-content {\r\n  font-size: 24px;\r\n  color: #1890ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
